import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentoclienteService } from '../services/documentocliente/documentocliente.service';
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Toast } from '../config/config';

declare var grecaptcha: any;
declare function init_plugins();
declare const gapi: any;

@Component({
  standalone: false,
  selector: 'app-consultacomprobante',
  templateUrl: './consultacomprobante.component.html',
  styleUrls: ['./consultacomprobante.component.css']
})
export class ConsultacomprobanteComponent implements OnInit {
  model: NgbDateStruct;
  captchaError: boolean = false;
  valcaptcha: boolean = false;
  public dattipdoc: any = { text: 'descripcionpublica', value: 'codigosunat' };

  constructor(
    public documentoclienteService: DocumentoclienteService,
    private fb: FormBuilder,

    ) { }
    docForm: FormGroup;

    lstipodocs:any=[];
    docrespuesta:any;
    response:any;
    toast:any = Toast;
    keyclient:any =environment.keyclient;
    // fecha:any;
    loadRegister:boolean=false;
    loadXML:boolean=false;
    loadCDR:boolean=false;
    loadPDF:boolean=false;
    hasFormErrors = false;

  ngOnInit() {
    init_plugins();
    this.listarTipoDocumentosPublicos();

    this.docForm = new FormGroup({
      TipoDocumentoId: new FormControl( null , Validators.required ),
      RUCEmisor: new FormControl( null , Validators.required ),
      NumeroSerie: new FormControl( null , Validators.required ),
      MontoEmitido: new FormControl( null , Validators.required ),
      fecha: new FormControl( null , Validators.required ),
      NumeroComprobante: new FormControl( null , Validators.required )
    } );
    this.toast.fire({
      icon: 'info',
      title: '!Si no visualiza la validación captcha, refresque la página'
    })
  }

  contador(){
    this.observer().subscribe(numero =>{
      if(numero==59){console.log("ok");this.valcaptcha=false}},error => console.log("error"),() => console.log("termino!"));
  }
  observer(): Observable<number>{
    let obs = new Observable<number>(observer =>{
      let contador =0;
     let intervalo = setInterval(() => {
       contador +=1;
       observer.next(contador);
       if(contador == 60){clearInterval(intervalo);observer.complete();}
     }, 1000);
   });
   return obs;
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.docForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  listarTipoDocumentosPublicos() {
    this.documentoclienteService.listarTipoDocumentosPublicos({}).subscribe(resp => {
      if (resp.estado==1) {
        this.lstipodocs = resp.aaData;
      }
    });
  }
  descargapdfdocumento() {
    this.loadPDF=true;
    let obj:any ={};
    obj.iddocumento = this.docrespuesta.id_documento;
    obj.id_local = this.docrespuesta.idlocal;
    obj.cod_tipo_documento = this.docrespuesta.cod_tipo_documento;
    this.documentoclienteService.descargapdfdocumento(obj).subscribe(resp => {   
      if (resp) {
        var file = new Blob([resp], { type: "application/pdf" });
        saveAs(file, "reportes.pdf");
      }else{
        // Swal.fire("Error en la transaccion", resp.msg, "error");
        this.toast.fire({
          icon: 'error',
          title: resp.msg
        })
      }
      this.loadPDF=false;

    },error=>{
      this.loadPDF=false;

    });
  }

  descargarDocumentoCPE(tipo) {
    this.response = grecaptcha.getResponse();
    if (this.response.length === 0) {
      this.captchaError = true;
      return;
    }
    if(tipo=='CPE'){this.loadXML=true}else{this.loadCDR=true;}
    let obj:any ={};
    obj.iddocumento = this.docrespuesta.id_documento;
    obj.tipo_comprobante = tipo;

    this.documentoclienteService.descargarDocumentoCPE(obj).subscribe(resp => {   
      if (resp.estado==1) {
        const byteCharacters = atob(resp.file);
        let byteNumbers = [];
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        var file = new Blob([byteArray], { type: "application/xml" });
        saveAs(file, resp.file_nombre);
      } else {
        // Swal.fire("Error en la transaccion", resp.msg, "error");
        this.toast.fire({
          icon: 'error',
          title: resp.msg
        })
      }
      if(tipo=='CPE'){this.loadXML=false}else{this.loadCDR=false;}

    },error=>{
      if(tipo=='CPE'){this.loadXML=false}else{this.loadCDR=false;}

    });
  }

  reloadcatpcha(){
    // console.log(grecaptcha.render('recaptcha',{'sitekey':'6LeDuGMaAAAAABM_mKJ2j0Kwql2q6Qb397hL8LGI'}));
    grecaptcha.reset();
    // grecaptcha.render('recaptcha',{'sitekey':'6LeDuGMaAAAAABM_mKJ2j0Kwql2q6Qb397hL8LGI'});
  }

  consultar() {   
    this.loadRegister=true;
    if ( this.docForm.invalid ) {
      this.loadRegister=false;
      return;
    }

    this.response = grecaptcha.getResponse();
    if (this.response.length === 0) {
      this.captchaError = true;
      this.loadRegister=false;
      return;
    }
    this.contador();
    let obj :any={};
    obj.cod_tipo_documento = this.docForm.value.TipoDocumentoId;
    obj.nro_comprobante = this.docForm.value.NumeroComprobante;
    obj.serie_comprobante = this.docForm.value.NumeroSerie;
    obj.total = this.docForm.value.MontoEmitido;
    obj.fecha_documento = this.docForm.value.fecha;
    obj.nro_documento_empresa = this.docForm.value.RUCEmisor;
    obj.keyclient = this.response;
    this.documentoclienteService.retornaDocumentoPublico(obj).subscribe(resp => {
      if (resp.estado==1) {
        this.valcaptcha=true;
        this.docrespuesta=resp.aaData[0];
        this.toast.fire({
          icon: 'success',
          title: 'Correcto'
        })
      }
      else {
        this.valcaptcha=false;

        // Swal.fire("Error en la transaccion", resp.msg, "error");
        this.toast.fire({
          icon: 'error',
          title: resp.msg
        })
      }
      this.loadRegister=false;
    },error=>{
      this.loadRegister=false;

    });
  }



  resolved(res:any[]){
    console.log(res);
  }
}
